const autoNgTemplateLoaderTemplate1 = require('./dashboardClusterAgentInfo.html');

angular.module('portainer.docker').component('dashboardClusterAgentInfo', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'DashboardClusterAgentInfoController',
  bindings: {
    endpointId: '<',
  },
});
